var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGettr = function SvgGettr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "gettr",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "invis logoShards",
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4000,
    strokeDasharray: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    "data-id": 0,
    d: "M253.442 163.431l1.778 13.64-29.859 16.092z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 1,
    d: "M432.975 329.344h30.741l-20.291-9.358z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 2,
    d: "M446.467 329.344l20.863 34.367 6.333-23.66z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 3,
    d: "M259.542 210.823l19.088-8.787-13.08-13.402z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 4,
    d: "M144.11 341.051h46.352v20.795z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 5,
    d: "M259.542 210.823l12.48 12.502c2.876-3.813 4.904-7.728 5.985-11.762z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 6,
    d: "M259.542 210.823l6.01-22.192-22.873 30.378z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 7,
    d: "M7.688 298.199l19.131-33.15 1.052 43.977z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 8,
    d: "M144.11 341.051l-27.86 20.795V261.233z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 9,
    d: "M497.197 292.341l-11.466 16.956 9.525-2.302a32.486 32.486 0 001.941-14.654z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 10,
    d: "M26.82 265.05c10.384-5.774 26.223-9.813 47.852-5.4L62.26 281.67z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 11,
    d: "M64.777 339.06l-17.865 11.134 10.241 13.521z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 12,
    d: "M167.286 261.233l-23.177 21.04 46.353-21.04z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 13,
    d: "M184.714 301.206v20.915H144.11z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 14,
    d: "M242.19 169.576c-6.308 9.708-13.52 17.875-16.9 23.704l28.151-29.849z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 15,
    d: "M144.11 301.205l40.604.001-40.605 20.915z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 16,
    d: "M64.777 339.06l10.542 6.454-13.299 2.463z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 17,
    d: "M234.57 361.821v-79.547l13.787 20.532z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 18,
    d: "M201.707 261.231l12.746 21.043 9.747-8.635z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 19,
    d: "M27.871 309.026c2.187-18.938 16.39-29.023 34.388-27.356l-35.44-16.62z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 20,
    d: "M1.378 298.628l14.241 15.385L7.688 298.2z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 21,
    d: "M306.66 261.233l27.524 5.933-27.524 15.107z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 22,
    d: "M116.25 261.233l27.86 21.04-9.362 31.959z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 23,
    d: "M282.671 282.274l-20.117-21.044 8.762 16.232z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 24,
    d: "M32.412 359.231c7.15 2.726 15.111 4.542 24.742 4.484l-10.242-13.521z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 25,
    d: "M334.184 267.166l5.257 15.107 16.027-10.52z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 26,
    d: "M355.468 271.753l31.778-10.52v21.04z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 27,
    d: "M28.957 318.86l3.455 40.37 32.365-20.17c-18.216 4.06-30.975-6.135-35.82-20.2z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 28,
    d: "M1.378 298.628c2.81-10.907 9.103-24.145 25.441-33.58l-19.131 33.15z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 29,
    d: "M62.26 281.67l12.412-22.022c6.235 1.29 12.277 3.344 18.212 5.817z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 30,
    d: "M404.987 261.231v102.484l27.987-34.37z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 31,
    d: "M259.542 210.823l3.872 22.158a88.661 88.661 0 008.607-9.656z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 32,
    d: "M144.11 282.273v58.778l-9.362-26.82z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 33,
    d: "M248.357 302.806l-13.787-20.532h27.984z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 34,
    d: "M456.333 282.274l34.104-7.469c-5.44-6.844-14.685-13.574-27.357-13.574z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 35,
    d: "M490.437 274.805l-10.08 10.239-8.869-6.089z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 36,
    d: "M483.313 294.242l2.418 15.055 11.466-16.956z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 37,
    d: "M190.462 282.274v-21.04l-46.353 21.04z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 38,
    d: "M201.707 261.231h38.34L224.2 273.64z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 39,
    d: "M92.763 308.424l-.127 47.693-13.929-23.847z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 40,
    d: "M432.974 308.422h23.361l-23.36 20.922z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 41,
    d: "M64.777 308.422l27.86 47.695-27.86-17.058z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 42,
    d: "M469.43 296.142l27.767-3.8c-1.138-9.62-4.237-13.927-6.76-17.537z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 43,
    d: "M64.777 308.422l13.93 23.848 14.056-23.845z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 44,
    d: "M214.453 282.274h20.117l-10.37-8.635z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 45,
    d: "M456.335 282.274c8.98.424 13.374 7.45 13.094 13.868l2.06-17.187z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 46,
    d: "M432.974 282.274h23.361l-5.541-12.454z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 47,
    d: "M262.554 361.846l-14.197-59.04 14.197-20.532z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 48,
    d: "M477.326 326.356l-3.663 13.694-9.947-10.706z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 49,
    d: "M456.335 308.422l20.99 17.934-33.9-6.37z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 50,
    d: "M262.554 261.23l32.862.001-12.745 21.043z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 51,
    d: "M15.62 314.013l14.24 15.388-.903-10.54z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 52,
    d: "M446.467 329.344h17.25l9.946 10.706z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 53,
    d: "M404.987 363.716l27.988-34.372v34.371z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 54,
    d: "M254.613 241.723l8.801-8.742-3.872-22.158z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 55,
    d: "M234.567 361.846l13.79-59.04 14.197 59.04z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 56,
    d: "M224.2 273.64l10.37 8.634 36.746-4.812z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 57,
    d: "M62.26 281.67c4.73.93 10.876 2.32 17.505 5.336l13.12-21.54z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 58,
    d: "M255.22 177.07l10.33 11.564c.065-2.895-.223-5.06-.587-8.008z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 59,
    d: "M306.66 261.233l48.811 10.521 31.775-10.52z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 60,
    d: "M15.62 314.013l12.251-4.987L7.688 298.2z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 61,
    d: "M259.542 210.823l-16.863 8.186 11.934 22.714z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 62,
    d: "M57.154 363.716l4.866-15.74 13.3-2.462z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 63,
    d: "M404.987 261.231l27.987 21.043.001 47.07z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 64,
    d: "M339.441 282.273l16.03-10.519 31.775 10.52z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 65,
    d: "M469.43 296.142l10.927-11.098-8.869-6.089z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 66,
    d: "M225.361 193.163l29.86-16.093-20.578 41.768z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 67,
    d: "M477.324 326.356c8.884-4.06 14.414-10.558 17.933-19.362l-21.625 5.228z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 68,
    d: "M469.43 296.142l4.202 16.08 12.1-2.925z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 69,
    d: "M250.732 275.792l20.584 1.67-8.762-16.232z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 70,
    d: "M250.732 275.792l11.822-14.562-22.507.001z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 71,
    d: "M144.11 282.273l-27.86-21.04h51.036z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 72,
    d: "M234.643 218.838l8.036.171-3.285 21.478z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 73,
    d: "M248.56 152.771c1.747 2.212 3.417 5.292 4.882 10.66l-11.252 6.145c5.202-8.496 5.582-12.46 6.37-16.805z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 74,
    d: "M333.147 282.274v79.572l27.86-79.572z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 75,
    d: "M255.22 177.07l9.743 3.556c-.423-2.738-1.579-9.972-5.784-15.155-.304 5.96-2.07 8.933-3.959 11.6z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 76,
    d: "M240.047 261.231L224.2 273.64l26.532 2.153z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 77,
    d: "M259.542 210.823l19.088-8.787c.525 4.401-.15 7.313-.623 9.527z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 78,
    d: "M14.382 346.551c4.781 5.096 10.495 9.532 18.03 12.68l-2.552-29.83z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 79,
    d: "M404.987 261.231h58.095l-30.108 21.043z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 80,
    d: "M282.671 282.274h-48.1l36.745-4.812z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 81,
    d: "M254.613 241.723c-2.539 2.692-4.815 5.421-6.05 8.3a530.797 530.797 0 01-9.166-9.536z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 82,
    d: "M239.394 240.487l3.285-21.478 11.934 22.714z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 83,
    d: "M1.38 298.625l28.48 30.776-15.478 17.152C7.037 338.318-3.87 322.216 1.38 298.625z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 84,
    d: "M456.333 282.274l6.747-21.043-12.286 8.59z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 85,
    d: "M255.22 177.07l10.333 11.564-22.874 30.375z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 86,
    d: "M57.154 363.716c12.08-.123 23.913-2.612 35.482-7.599L75.32 345.514z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 87,
    d: "M242.68 219.01l12.54-41.94-20.577 41.768z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 88,
    d: "M306.66 282.273h32.781l-5.257-15.107z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 89,
    d: "M469.43 296.142l13.883-1.9 2.418 15.055z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 90,
    d: "M234.643 218.838l4.754 21.65c-12.343-13.204-14.74-18.29-16.75-22.129z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 91,
    d: "M28.957 318.86c-1.362-3.02-1.496-5.689-1.086-9.834l-12.252 4.987z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 92,
    d: "M265.553 188.634l13.077 13.402c-.372-3.52-.96-5.699-2.332-9.156z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 93,
    d: "M467.332 363.711l9.994-37.355 22.611 37.355z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 94,
    d: "M116.25 361.846h74.212l-46.353-20.795z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 95,
    d: "M469.43 296.142c-.727 7.493-6.634 12.28-13.095 12.28l20.991 17.934z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 96,
    d: "M477.326 326.356l-13.61 2.988-20.288-9.362z",
    fill: "#000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 97,
    d: "M265.55 188.634c2.475-2.527 3.7-5.587 3.875-9.093 2.48 3.817 5.104 9.144 6.873 13.34z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 98,
    d: "M225.361 193.163c-3.127 5.13-7.256 14.419-2.714 25.196l11.996.48z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 99,
    d: "M333.147 361.846l27.86-79.572v79.572z",
    fill: "#000",
    fillOpacity: 1
  }))));
};
export default SvgGettr;